import { normalizarValorCeldaExcel } from './fechaImportacion';

/**
 * Localiza el encabezado de tasa nocturna aunque varíe mayúsculas o espacios.
 */
export function buscarHeaderTasaNocturna(headers) {
  return (headers || []).find((header) => {
    const texto = String(header ?? '')
      .trim()
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '');
    return /considerar.*tasa.*nocturna/.test(texto) || texto === 'tasa nocturna';
  });
}

/**
 * Parsea el valor de columna Excel "Considerar tasa nocturna" (Si / No).
 */
export function parsearConsiderarTasaNocturnaExcel(valor) {
  const escalar = normalizarValorCeldaExcel(valor);

  if (escalar === true || escalar === 1) {
    return { valido: true, valor: true };
  }

  if (escalar === false || escalar === 0) {
    return { valido: true, valor: false };
  }

  if (escalar === null || escalar === undefined || String(escalar).trim() === '') {
    return { valido: true, valor: false };
  }

  const normalizado = String(escalar)    .trim()
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '');

  if (['si', 's', 'yes', '1', 'true'].includes(normalizado)) {
    return { valido: true, valor: true };
  }

  if (['no', 'n', '0', 'false'].includes(normalizado)) {
    return { valido: true, valor: false };
  }

  return { valido: false, valor: false };
}

/**
 * Aplica el flag de tasa nocturna a un payload de tareo cuando corresponde.
 */
export function aplicarFlagTasaNocturna(tareoData, tasaNocturnaActiva, marcado) {
  if (tasaNocturnaActiva && marcado) {
    return { ...tareoData, considerar_tasa_nocturna: true };
  }
  return tareoData;
}

/**
 * Prepara filas de importación: quita metadatos y respeta el flag por fila del Excel.
 */
export function prepararTareosImportacion(filasValidas, tasaNocturnaActiva) {
  return filasValidas.map(({ fila, considerar_tasa_nocturna, ...tareo }) => {
    const limpio = Object.fromEntries(
      Object.entries(tareo).filter(([key]) => !String(key).startsWith('_'))
    );
    if (!tasaNocturnaActiva) return limpio;
    return {
      ...limpio,
      considerar_tasa_nocturna: Boolean(considerar_tasa_nocturna),
    };
  });
}
